/* Ott-common */
import { EntityName } from '@dtvgo/backend-service/normalize';
import { returnNull } from '@dtvgo/typed-normalizr';

/* Selectors */
import { selectContentById } from './contents';
import { selectPageById } from './pages';
import { selectSeasonById } from './seasons';
import { selectCarouselById } from './carousels';
import { selectShowById } from './shows';
import { selectChannelById } from './channels';
import { selectScheduleById } from './schedules';

export function selectPolymorphicEntityById({ id, schema }) {
  switch (schema) {
    case EntityName.PAGE: {
      return selectPageById(id);
    }
    case EntityName.CAROUSEL: {
      return selectCarouselById(id);
    }
    case EntityName.CHANNEL: {
      return selectChannelById(id);
    }
    case EntityName.SHOW: {
      return selectShowById(id);
    }
    case EntityName.SEASON: {
      return selectSeasonById(id);
    }
    case EntityName.CONTENT: {
      return selectContentById(id);
    }
    case EntityName.SCHEDULE: {
      return selectScheduleById(id);
    }
    default: {
      return returnNull;
    }
  }
}

export const selectMultiplePolymorphicEntities = (polymorphicObjectsList) => {
  const selectors = polymorphicObjectsList?.map(selectPolymorphicEntityById);
  return (state) => (
    selectors?.map((selector) => selector(state)).filter((entity) => !!entity)
  );
};
